import Select from "react-select";
import {useQuery} from "react-query";
import React, {useEffect, useState, useMemo} from "react";
import {getChildren} from "Api/Query/ChildrenQuery";
import {SelectOptionCollection} from "Model/Select/SelectOptionCollection";
import {SelectOption} from "Model/Select/SelectOption";

interface Props {
    onChange: (newValue: any) => void,
    value: any,
    classes?: string,
    centerIds?: string[]
}

export const AllChildSelect : React.FC<Props> = (props) => {

    const [options, setOptions] = useState<any>([])

    // Sincroniza la opción seleccionada si cambia props.value u options
    const selectedOption = useMemo(() => {
        if (!props.value) return null
        const selectedId =
            typeof props.value === 'string'
                ? props.value
                : (props.value?.id ?? props.value?.value ?? null)
        if (!selectedId) return null
        return options.find((o: any) => o.value === selectedId) ?? null
    }, [props.value, options])

    const {
        isLoading,
        data,
    } = useQuery(['children', props.centerIds], () => getChildren({},'name', 0))

    useEffect(() => {
        if(!data) return

        // @ts-ignore
        const response : ApiListResponse = data?.data
        const childrenItems : any[] = response._result.items ?? []
        const collection = new SelectOptionCollection()

        if(childrenItems.length){
            for (const child of childrenItems) {
                const label = `${child.name} ${child.surnames}`
                const option = SelectOption.fromPrimitives(label, child.id)
                collection.addPrimitive(option)
            }
        }

        setOptions(collection.toPrimitiveOptions())
    }, [data])

    return (
        <Select
            isLoading={isLoading}
            options={options}
            placeholder={""}
            noOptionsMessage={() => "No hay resultados"}
            isClearable={true}
            loadingMessage={() => "Cargando ..."}
            onChange={props.onChange}
            className={props.classes ?? ''}
            value={selectedOption}
        />
    )
}
